  $('.mobile-block-header').on('click', function() {
      // Get the content block related to the clicked header
      var contentBlock = $(this).closest('.content-block').find('.content-mob-block');
      
      // Check if this block is already visible
      if (contentBlock.is(':visible')) {
        // If it's open, close it and remove active class
        contentBlock.slideUp();
        $(this).removeClass('active');
      } else {
        // Close only other blocks in the same 'mobile-view-setup' section
        $(this).closest('.mobile-view-setup').find('.content-mob-block').slideUp();
        $(this).closest('.mobile-view-setup').find('.mobile-block-header').removeClass('active');
        
        // Open the clicked block and add active class to its header
        contentBlock.slideDown();
        $(this).addClass('active');
      }
    });


 $('.solution-button').on('click', function() {
    var targetContent = $(this).data('target'); // Get the target content selector

    // Remove 'active' class from all buttons and add to the clicked one
    $('.solution-button').removeClass('active');
    $(this).addClass('active');
    
    // Hide all other content and show only the target content with fade-in effect
    $('.same-deafult-cl-content').hide();
    $(targetContent).fadeIn('slow');
  });




$(document).ready(function(){
  // Open by default logic
  $('.faq-question').each(function() {
    var $this = $(this);
    if ($this.data('open-default') == true) {
      $this.addClass('active'); // Add active class to question
      $this.closest('.faq-item-custom').find('.faq-answer').slideDown(); // Show the related answer
    }
  });

  // Toggle functionality on question click
  $('.faq-question').click(function(){
    var $this = $(this); // Cache the clicked element

    // Find the closest answer and toggle it
    $this.closest('.faq-item-custom').find('.faq-answer').slideToggle();

    // Toggle 'active' class on the question itself
    $this.toggleClass('active');
  });
});



// JavaScript for sticky header effect
window.onscroll = function() {
  var header = document.querySelector('.main_site_header');
  var body = document.querySelector('body');
  if (window.pageYOffset > 0) {
    header.classList.add('is-sticky');
    body.classList.add('header-sticky');
  } else {
    header.classList.remove('is-sticky');
    body.classList.remove('header-sticky');
  }
};



   let rangeMin = 100;
const range = document.querySelector(".range-selected");
const rangeInput = document.querySelectorAll(".range-input input");
const rangePrice = document.querySelectorAll(".range-price input");
   rangeInput.forEach((input) => {
  input.addEventListener("input", (e) => {
    let minRange = parseInt(rangeInput[0].value);
    let maxRange = parseInt(rangeInput[1].value);
    if (maxRange - minRange < rangeMin) {     
      if (e.target.className === "min") {
        rangeInput[0].value = maxRange - rangeMin;        
      } else {
        rangeInput[1].value = minRange + rangeMin;        
      }
    } else {
      rangePrice[0].value = minRange;
      rangePrice[1].value = maxRange;
      range.style.left = (minRange / rangeInput[0].max) * 100 + "%";
      range.style.right = 100 - (maxRange / rangeInput[1].max) * 100 + "%";
    }
  });
});
   rangePrice.forEach((input) => {
  input.addEventListener("input", (e) => {
    let minPrice = rangePrice[0].value;
    let maxPrice = rangePrice[1].value;
    if (maxPrice - minPrice >= rangeMin && maxPrice <= rangeInput[1].max) {
      if (e.target.className === "min") {
        rangeInput[0].value = minPrice;
        range.style.left = (minPrice / rangeInput[0].max) * 100 + "%";
      } else {
        rangeInput[1].value = maxPrice;
        range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
      }
    }
  });
});




    function scrollLeft2() {
        document.querySelector('.custom-upsell-cart').scrollBy({
            left: -200, // Adjust to control scroll distance
            behavior: 'smooth'
        });
    }

    function scrollRight() {
        document.querySelector('.custom-upsell-cart').scrollBy({
            left: 200, // Adjust to control scroll distance
            behavior: 'smooth'
        });
    }

    function checkScroll() {
        const scrollContainer = document.querySelector('.custom-upsell-cart');
        const scrollLeftBtn = document.getElementById('scrollLeftBtn');
        const scrollRightBtn = document.getElementById('scrollRightBtn');

        // Show/hide the left arrow if there's content on the left
        if (scrollContainer.scrollLeft > 0) {
            scrollLeftBtn.style.display = 'block';
        } else {
            scrollLeftBtn.style.display = 'none';
        }

        // Show/hide the right arrow if there's content on the right
        if (scrollContainer.scrollLeft < scrollContainer.scrollWidth - scrollContainer.clientWidth) {
            scrollRightBtn.style.display = 'block';
        } else {
            scrollRightBtn.style.display = 'none';
        }
    }

    // Check the scroll position on page load
    document.addEventListener("DOMContentLoaded", checkScroll);




$(document).ready(function() {
  $(".tab-heading").click(function() {
    $(this).toggleClass("active");
    $(this).next(".tab-contentcustom-2").slideToggle().toggleClass("open");
  });
});

$(document).ready(function () {
    $(".table-content-li").on("click", function (e) {
        e.preventDefault();
      //console.log('scroll div');
        var targetId = $(this).attr("href"); // Get the ID from href
        var target = $(targetId);
        var container = $("#scrollable-container");
        console.log(target); 
        if (target.length && container.length) {
          //console.log('animation scroll');
            // container.animate({
            //     scrollTop: container.scrollTop() + target.position().top
            // }, 500); // Adjust scroll speed (500ms)
           $('html, body').animate({
                scrollTop: $(targetId).offset().top - 130
            }, 800);
        }
    });
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    //links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
